import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class VideosService extends ApiService {
  constructor(public http: HttpClient, private cookieService: CookieService) {
    super(http);
  }

  public getAll(): Observable<Video[]> {
    return this.http.get<Video[]>(this.endpoint(`api`, `videos`));
  }

  public delete(id: string): Observable<Video> {
    return this.http.delete<Video>(this.endpoint(`api`, `videos`, id));
  }

  public post(video: Video): Observable<Video> {
    return this.http.post<Video>(this.endpoint(`api`, `videos`), this.createFromData(video));
  }

  public put(id: string, video: Video): Observable<Video> {
    return this.http.put<any>(this.endpoint(`api`, `videos`, id), this.createFromData(video));
  }

  private createFromData(video: Video) {
    const formData = new FormData();
    formData.append('title', video.title);
    formData.append('description', video.description);
    if (video.externalLink) {
      formData.append('externalLink', video.externalLink);
    }
    if (video.videoFile) {
      formData.append('video', video.videoFile);
    }
    if (video.thumbnailFile) {
      formData.append('thumbnail', video.thumbnailFile);
    }
    if (video.thumbnailDeleted) {
      formData.append('thumbnailDeleted', video.thumbnailDeleted.toString());
    }
    if (video.videoMimeType) {
      formData.append('mimeType', video.videoMimeType);
    }
    if (video.videoDuration) {
      formData.append('duration', video.videoDuration.toString());
    }
    return formData;
  }
}

export interface Video {
  id: string;
  title: string;
  description: string;
  externalLink: string;
  videoFile: any;
  thumbnailFile: any;
  thumbnailDeleted: boolean | 0;
  videoMimeType: string;
  videoDuration: number;

  isExternal: boolean;
  modifiedMimeType: string;
  videoBlob: any;
  videoUrl: string;
  thumbnailBlob: any;
  thumbnail: any;
  duration: number;
  durationString: string;
}
